/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactcasebrieftitle3Inputs */

const en_artifactcasebrieftitle3 = /** @type {(inputs: Artifactcasebrieftitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case file (~12 pages)`)
};

const pt_artifactcasebrieftitle3 = /** @type {(inputs: Artifactcasebrieftitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dossier de caso (~12 páginas)`)
};

/**
* | output |
* | --- |
* | "Case file (~12 pages)" |
*
* @param {Artifactcasebrieftitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactcasebrieftitle3 = /** @type {((inputs?: Artifactcasebrieftitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactcasebrieftitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactcasebrieftitle3(inputs)
	return pt_artifactcasebrieftitle3(inputs)
});
export { artifactcasebrieftitle3 as "artifactCaseBriefTitle" }